import React, { useEffect } from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import NewHeaderStatic from "../Component/NewHeader/NewHeaderStatic.js";
import FooterStatic from "../Component/FooterStatic";
import {Helmet} from "react-helmet";

const Faq = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="StaticMainComponent">
      <div className="MainStaticMainComponentContaint">
      <Helmet>
      <title>FAQ's : Holidays Seychelles</title>
      <meta name="keywords" content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"/>
      <meta name="description" content="Solve all your queries on the best place for honeymoon Seychelles and beautiful places in the world." />
    </Helmet>
    <h1 style={{color:'#fff'}}> FAQ's : Holidays Seychelles</h1>
        <NewHeaderStatic page={"inner_listing"} />
        <div
          className="StaticlandingCard appendBottom20 StaticSection page-section"
          style={{ marginTop: 150 }}
        >
          <div className="StaticContainer" id="container">
            <div class="row">
              <div className="aboutPage">
                <h1 className="aboutHeading">FAQs</h1>
                <p className="text" style={{marginTop:'2%'}}>
                We hope the below cover the main things you need. If not, send us an email. Contact details can be found on the Contact Us page of this website.
                </p>

                <h3>Who can I contact in case of a problem?</h3>
                <p className="text">
                Holidays Seychelles office number +248 437 6666.
                </p>
                <h3>How does the payment process work? </h3>
                <p className="text">
                The website is connected to cyber source payment gateway. This in itself provides all the necessary security and compliance to international standards to ensure the safety of your details and money. If you are familiar with online payment our payment process will follow the same process and authentication.
                </p>
                <h3>
                I am having problem to register.
                </h3>
                <p className="text">
                We hope the below cover the main things you need. If not, send us an email. Contact details can be found on the Contact Us page of this website.
                </p>
                <h3>
                What kind of experiences can I Book here?
                </h3>
                <p className="text">
                This website has been designed to cater for all kind of experiences possible. 
                </p>
                <h3>
                Who will maintain all my information?
                </h3>
                <p className="text">
                Once you have completed your registration process. You will be given your own login credentials for you to maintain all your booking data. 
                </p>
                <h3>
                Am I actually booking with Holidays Seychelles or with the local partner?
                </h3>
                <p className="text">
                You are booking with Holidays Seychelles. However, the booking details are transferred to the hotel or event supplier instantly for prompt action and ensure a proper quality service delivery. 
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterStatic showNews={"noNews"} />
    </div>
  );
};

export default Faq;
